import { render, staticRenderFns } from "./TableRowCostPerUnit.vue?vue&type=template&id=c718eb64&lang=pug&"
import script from "./TableRowCostPerUnit.vue?vue&type=script&lang=js&"
export * from "./TableRowCostPerUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c718eb64')) {
      api.createRecord('c718eb64', component.options)
    } else {
      api.reload('c718eb64', component.options)
    }
    module.hot.accept("./TableRowCostPerUnit.vue?vue&type=template&id=c718eb64&lang=pug&", function () {
      api.rerender('c718eb64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowCostPerUnit.vue"
export default component.exports